import { Component, TemplateRef } from '@angular/core';

import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from './toast.service';

@Component({
	selector: 'app-toasts',
	standalone: true,
	imports: [NgbToastModule, NgIf, NgTemplateOutlet, NgFor],
	template: `
		<div style="position: fixed !important; top: 20px !important; right: 20px !important; z-index: 999999 !important; max-width: 450px; width: calc(100% - 40px); pointer-events: auto;">
			<div *ngFor="let toast of toastService.toasts" [class]="'shadow-lg rounded p-3 mb-2 text-white d-flex align-items-center justify-content-between ' + (toast.classname || 'bg-success')" style="display: flex !important; opacity: 1 !important; visibility: visible !important; font-size: 15px; font-weight: 500; min-height: 50px;">
				<div style="flex: 1; padding-right: 15px;">
					<ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
						<ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
					</ng-template>
					<ng-template #text><span>{{ toast.textOrTpl }}</span></ng-template>
				</div>
				<button type="button" class="btn-close btn-close-white" (click)="toastService.remove(toast)" style="cursor: pointer; opacity: 0.9; flex-shrink: 0;" aria-label="Fermer"></button>
			</div>
		</div>
	`,
})
export class ToastsContainer {
	constructor(public toastService: ToastService) {}

	isTemplate(toast:any) {
		return toast.textOrTpl instanceof TemplateRef;
	}
}